import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TableColumn } from '../../../dto/util/table-column';
import { FiltroDto } from '../../../dto/util/filtro-dto';
import { ExpedienteFiltroDto } from '../../../dto/expediente/expediente.filtro.dto';
import { TipoDocumentoDto } from '../../../dto/expediente/tipo-documento-dto.dto';
import { InfoPantallaDTO } from '../../../dto/util/infoPantallaDTO';
import { ExpedienteService } from '../../../services/expediente.service';
import { ListasService } from '../../../services/listas.service';
import { UtilService } from '../../../services/util.service';
import { ModalService } from '../../../services/util/modal.service';
import { Constants } from '../../../constants/constants';
import { SolicitudDocumentosComponent } from '../solicitud-documentos/solicitud-documentos.component';
import {
  PartesProcesoSupersociedadesMercantilesDto
} from '../../../dto/expediente/partes-proceso.supersociedades-mercantiles.dto';
import {
  ActuacionesSupersociedadesMercantilesDto
} from '../../../dto/expediente/actuaciones-supersociedades-mercantiles.dto';
import {
  ExpedienteSupersociedadesMercantilesDto
} from '../../../dto/expediente/expediente-supersociedades-mercantiles.dto';
import { ExpedienteSuperfinancieraDto } from '../../../dto/expediente/expediente-superfinanciera.dto';
import { HistorialExpedienteSuperfinancieraDto } from '../../../dto/expediente/historial-expediente-superfinanciera.dto';
import { DocumentosDescargaRequestDto } from '../../../dto/expediente/documentos.dto';
import { DescargaDocumentosComponent } from '../descarga-documentos/descarga-documentos.component';
import { TranslateService } from "@ngx-translate/core";
import { combineLatest } from 'rxjs';
import {EntidadService} from "../../../services/entidad.service";
import {EntidadApiResponse} from "../../../dto/entidad/entidad-response.dto";
import { Entidades } from '../../../constants/entidades.constants';

@Component({
  selector: 'app-detalle-supersociedades-mercantiles',
  templateUrl: './detalle-supersociedades-mercantiles.component.html',
  styleUrl: './detalle-supersociedades-mercantiles.component.scss',
})
export class DetalleSupersociedadesMercantilesComponent implements OnInit {
  private activatedRoute = inject(ActivatedRoute);
  entidadId = 1;
  expedienteId = 0;
  usuarioCreadorId = 0;
  expedienteData?: ExpedienteSupersociedadesMercantilesDto;
  partesProceso: PartesProcesoSupersociedadesMercantilesDto[] = [];
  actuaciones: ActuacionesSupersociedadesMercantilesDto[] = [];
  columnsActuaciones: TableColumn[] = [];
  columnsPartesProceso: TableColumn[] = [];
  tamanoPagina = 5;
  totalPaginas = 0;
  paginaActual = 1;
  showButton = true;
  isCreator = false;
  entidad!: EntidadApiResponse;
  // prueba
  expedienteSuperfinancieraDto?: ExpedienteSuperfinancieraDto;
  historialExpediente: HistorialExpedienteSuperfinancieraDto[] = [];
  tipoDocumentoUsuario = '';
  numeroIdentificacion = '';

  filtrosActuaciones: FiltroDto<ExpedienteFiltroDto> = {
    pagina: 1,
    tamanoPagina: 10,
    ordenarAsc: false,
    ordenarPor: 'actuacion',
    filtros: {},
  };

  filtrosPartesProceso: FiltroDto<ExpedienteFiltroDto> = {
    pagina: 1,
    tamanoPagina: 10,
    ordenarAsc: false,
    ordenarPor: 'parte',
    filtros: {},
  };

  // Información de la pantalla y guía interactiva
  infoPantalla!: InfoPantallaDTO;
  // Multilenguaje
  tableText: any = {};

  guiaText: any = {};
  guiaSupersociedadesText: any = {};
  showGuia:boolean = true;
  public role = '';

  constructor(
    private readonly service: ExpedienteService,
    private readonly router: Router,
    private readonly utilService: UtilService,
    private readonly modalService: ModalService,
    private readonly route: ActivatedRoute,
    private readonly translate: TranslateService,
    private entidadService: EntidadService,
    private readonly listaService: ListasService,
  ) {
    this.route.params.subscribe(params => {
      this.expedienteId = params['expedienteId'];
      this.usuarioCreadorId = params['usuarioId'];
    });
    const userData = sessionStorage.getItem(Constants.USER_TYPE);
    if (userData) {
      const parseObject = JSON.parse(userData);
      this.role = parseObject.Nombre;
    }
    // Multilenguaje
    combineLatest({
      tabla: this.translate.stream('detalle-supersociedades'),
      guias: this.translate.stream('guias-interactivas'),
      guiaSuperSalud: this.translate.stream('guia-supersociedades'),
    }).subscribe(({ tabla, guias, guiaSuperSalud }) => {
      // Asignar traducciones a variables
      this.tableText = tabla;
      this.guiaText = guias;
      this.guiaSupersociedadesText = guiaSuperSalud;
      this.ngOnInit();
    });
  }

  ngOnInit(): void {
    this.initColumns();
    this.cargarEntidad();
    // Se toma la información del usuario que inicia sesión
    const infoInicioSesion = JSON.parse(
      sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE) ?? '{}'
    );
    this.tipoDocumentoUsuario = infoInicioSesion.tipoDocumento;
    this.numeroIdentificacion = infoInicioSesion.identificacion;
    this.getExpendienteDetail(this.expedienteId,this.tipoDocumentoUsuario,this.numeroIdentificacion);
    this.utilService.watch().subscribe(val => {
      this.showButton = val;
    });
    this.utilService.setIdEntidad(this.entidadId);
    this.isCreator = infoInicioSesion.idUsuario === +this.usuarioCreadorId;
    // Se asigna información a InfoPantallaDTO
    this.infoPantalla = {
      tituloPantalla: this.guiaText['expediente-titulo'],
      descripcionPantalla: this.guiaSupersociedadesText['descripcion-pantalla'],
      pasos: [
        {
          element: '#tour',
          popover: {
            title: this.guiaSupersociedadesText['tour-titulo'],
            description: this.guiaText['tour-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#navbarDropdownDetalle',
          popover: {
            title: this.guiaText['usuario-titulo'],
            description: this.guiaText['usuario-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#dropdownAlertasButton',
          popover: {
            title: this.guiaText['alertas-titulo'],
            description: this.guiaText['alertas-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#glosario',
          popover: {
            title: this.guiaText['glosario-titulo'],
            description: this.guiaText['glosario-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#informacion',
          popover: {
            title: this.guiaText['info-titulo'],
            description: this.guiaText['info-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#encabezado',
          popover: {
            title: this.guiaSupersociedadesText['encabezado-titulo'],
            description: this.guiaSupersociedadesText['encabezado-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#crearSolicitud',
          popover: {
            title: this.guiaSupersociedadesText['crear-solicitud-titulo'],
            description: this.guiaSupersociedadesText['crear-solicitud-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#historicoBtn',
          popover: {
            title: this.guiaSupersociedadesText['historico-titulo'],
            description: this.guiaSupersociedadesText['historico-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#filtro',
          popover: {
            title: this.guiaSupersociedadesText['filtro-titulo'],
            description: this.guiaSupersociedadesText['filtro-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#historico',
          popover: {
            title: this.guiaSupersociedadesText['historico-titulo'],
            description: this.guiaSupersociedadesText['historico-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#actuacion',
          popover: {
            title: this.guiaSupersociedadesText['actuacion-titulo'],
            description: this.guiaSupersociedadesText['actuacion-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#Numero_Radicado',
          popover: {
            title: this.guiaSupersociedadesText['radicado-titulo'],
            description: this.guiaSupersociedadesText['radicado-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#anexos',
          popover: {
            title: this.guiaSupersociedadesText['anexos-titulo'],
            description: this.guiaSupersociedadesText['anexos-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#tramite',
          popover: {
            title: this.guiaSupersociedadesText['tramite-titulo'],
            description: this.guiaSupersociedadesText['tramite-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#Fecha',
          popover: {
            title: this.guiaSupersociedadesText['fecha-radicacion-titulo'],
            description: this.guiaSupersociedadesText['fecha-radicacion-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#entrada_salida',
          popover: {
            title: this.guiaSupersociedadesText['entrada-salida-titulo'],
            description: this.guiaSupersociedadesText['entrada-salida-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#cuaderno',
          popover: {
            title: this.guiaSupersociedadesText['cuaderno-titulo'],
            description: this.guiaSupersociedadesText['cuaderno-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
      ],
    };
    const isShowGuia = sessionStorage.getItem(Constants.SHOW_GUIA_DETALLE_SUPERSSM) != null ? false : this.showGuia
    // Se valida que sea el primer inicio de sesión para ejecutar la guía interactiva
    if (infoInicioSesion.primerInicioSesion && isShowGuia) {
      this.utilService.changeInfoPantalla(this.infoPantalla);
      this.utilService.iniciarGuiaInteractiva();
      sessionStorage.setItem(Constants.SHOW_GUIA_DETALLE_SUPERSSM, 'false')
    } else {
      this.utilService.changeInfoPantalla(this.infoPantalla);
    }
  }

  getExpendienteDetail(expedienteId: number, tipoDocumentoUsuario: string, numeroIdentificacion: string) {
    this.service
      .getExpedienteSupersociedadesMercantiles(expedienteId, tipoDocumentoUsuario, numeroIdentificacion)
      .subscribe({
        next: data => {
          this.expedienteData = data;
          if (data.partes) {
            this.partesProceso = data.partes;
          }

          this.actuaciones = this.expedienteData['actuaciones'] || [];
          this.formatearDatosActuaciones(this.actuaciones);

          this.actuaciones = this.actuaciones.map(historico => ({
            ...historico,
            anexos: 'Ver anexos',
          }));

          this.formatearDatosProceso(this.partesProceso);
          this.initColumns();
        },
        error: err => {
          console.error('Error getting data', err);
        },
      });
  }

  formatearDatosActuaciones(
    data: ExpedienteSupersociedadesMercantilesDto['actuaciones']
  ) {
    data.forEach((elemento: ActuacionesSupersociedadesMercantilesDto) => {
      const fechaString = elemento.Fecha || elemento.fechaActuacion;

      if (fechaString && fechaString !== Constants.SIN_RESPUESTA) {
        const [dia, mes, anio] = fechaString.split("/");
        const fecha = new Date(+anio, +mes - 1, +dia);

        elemento.Fecha = `${dia}/${mes}/${anio}`;

        (elemento as any).fechaOrdenable = `${anio}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`;
        (elemento as any).fechaTimestamp = fecha.getTime();
      } else {
        elemento.Fecha = Constants.SIN_RESPUESTA;
        (elemento as any).fechaOrdenable = Constants.FECHA_ORDENABLE;
        (elemento as any).fechaTimestamp = Constants.VALOR_TIMESTAMP;
      }

      elemento.Numero_Radicado = elemento.numeroRadicado ?? '';
      elemento.Tramite = elemento.Tramite ?? '';
      elemento.actuacion = elemento.actuaciones ?? '';
    });

    data.sort((a, b) => {
      const timestampA = (a as any).fechaTimestamp || Constants.VALOR_TIMESTAMP;
      const timestampB = (b as any).fechaTimestamp || Constants.VALOR_TIMESTAMP;
      return timestampB - timestampA;
    });
  }

  formatearDatosProceso(data: ExpedienteSupersociedadesMercantilesDto['partes']) {
    let numDocNit: string = '';

    data?.forEach((elemento: PartesProcesoSupersociedadesMercantilesDto) => {

      this.listaService.getTipoDocumentoAcronimo(elemento.tipoIdentificacion ?? '').subscribe((tiposDocumento: TipoDocumentoDto[]) => {
        const tipoDocEncontrado = tiposDocumento.find(tipo => tipo.Tipo_Documento === elemento.tipoIdentificacion);
        if (tipoDocEncontrado) {
          elemento.tipoIdentificacion = tipoDocEncontrado.Descripcion;
        }

        switch (elemento.tipoIdentificacion) {
          case Constants.TIPO_IDENTIFICACION_NIT:
            numDocNit = elemento.numeroIdentificacion!;
            elemento.numeroIdentificacion = numDocNit.replace(/\D/g, '');
            elemento.tipoPersona = Constants.TIPO_PERSONA_JURIDICA;
            break;
          case Constants.TIPO_IDENTIFICACION_CC:
            elemento.tipoPersona = Constants.TIPO_PERSONA_NATURAL;
            break;
          case Constants.TIPO_IDENTIFICACION_CE:
            elemento.tipoPersona = Constants.TIPO_PERSONA_NATURAL;
            break;
          case Constants.TIPO_IDENTIFICACION_CEDULA:
            elemento.tipoPersona = Constants.TIPO_PERSONA_NATURAL;
            break;
          default:
            elemento.tipoPersona = 'Desconocido';
            break;
        }
      });
    });
  }


  initColumns() {
    this.columnsPartesProceso = [
      {
        field: 'parte',
        title: this.tableText['parte'],
        type: 'text',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'parte',
      },
      {
        field: 'tipoIdentificacion',
        title: this.tableText['tipo-documento'],
        type: 'text',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'tipoIdentificacion',
      },
      {
        field: 'numeroIdentificacion',
        title: this.tableText['numero-documento'],
        type: 'number',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'numeroIdentificacion',
      },
      {
        field: 'tipoPersona',
        title: this.tableText['tipo-persona'],
        type: 'text',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'tipoPersona',
      },
    ];

    this.columnsActuaciones = [
      {
        field: 'actuacion',
        title: this.tableText['actuaciones'],
        type: 'text',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'actuaciones',
      },
      {
        field: 'Numero_Radicado',
        title: this.tableText['radicado'],
        type: 'number',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'Numero_Radicado',
      },
      {
        field: 'anexos',
        title: this.tableText['anexos'],
        type: 'text',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'anexos',
        accion: item => {
          this.openModalDocumentos(item);
        },
      },
      {
        field: 'tramite',
        title: this.tableText['tramite'],
        type: 'text',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'tramite',
      },
      {
        field: 'Fecha',
        title: this.tableText['fecha'],
        type: 'text',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'fechaOrdenable',
      },
      {
        field: 'entrada_salida',
        title: this.tableText['entrada-salida'],
        type: 'text',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'entrada_salida',
      },
      {
        field: 'cuaderno',
        title: this.tableText['cuaderno'],
        type: 'text',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'cuaderno',
      },
    ];
  }

  crearAvanceProcesal() {
    this.router.navigate([
      `expediente/${this.entidadId}/avance-procesal/${this.expedienteId}`,
    ]);
  }

  navigateAvanceProcesalSolicitudes() {
    this.router.navigate([
      `expediente/${this.entidadId}/avance-procesal/${this.expedienteId}/solicitudes`,
    ]);
  }

  openModal(): void {
    const modalData: any = {
      entidadId: this.entidadId,
      expedienteId: this.expedienteId,
      numeroProceso: this.expedienteData?.radicado,
    };
    this.modalService.openModal(SolicitudDocumentosComponent, modalData);
  }

  openModalDocumentos(item: any): void {
    console.log('item', item);
    const modalData: any = {
      ...item,
      entidadId: this.entidadId,
      expedienteId: this.expedienteId,
      numeroProceso: this.expedienteId,
      nombreEntidad: Entidades.SSOCIEDADES,
      radicado: item.numeroRadicado,
      esInsolvencia: false,
    };
    this.modalService.openModal(DescargaDocumentosComponent, modalData);
  }

  downloadPrincipalDocument(item: any): void {
    const req: DocumentosDescargaRequestDto = {
      ids: [parseInt(item.principal)],
      idEntidad: this.entidadId,
      expediente: this.expedienteId,
    };

    // this.documentosService.getDocumentosDescargaSsm(req, this.expedienteId,
    //   this.entidadId, item
    // ).subscribe(resp => {
    //   if (resp.zipBase64) this._downloadBase64File(resp.zipBase64, 'documento.zip');
    // });
  }

  private _downloadBase64File(base64: string, fileName: string): void {
    const link = document.createElement('a');
    link.href = `data:application/octet-stream;base64,${base64}`;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  cargarEntidad(): void {
    this.entidadService.obtenerEntidadPorId(this.entidadId).subscribe({
      next: (data) => {
        this.entidad = data;
      },
      error: (error) => console.error('Error al obtener la entidad:', error),
    });
  }
}
